/**
 * Created by Dhanya Akhil on 27/02/2017.
 */
import { Injectable, NgZone } from "@angular/core";
function _window(): any {
  // return the global native browser window object
  return window;
}
@Injectable()
export class WindowRef {
  constructor(private ngZone: NgZone) {}

  get nativeWindow(): any {
    return _window();
  }

 get isMobile() {
   let mobile =  this.ngZone.run(() => {
      if (window.innerWidth < 414) {
        return true;
      } else {
        return false;
      }
    });
    return mobile
  }
}
